import DataTable from "../../DataTable/DataTable";
import NoData from "../../Loading/NoData";
import { HeadingTitle } from "../ModalContainer";
import '../../../Pages/Styles/portalNetInventorySummary.css'

const ALTERNATE_HEADER = [
  <>
    Configuration Key
  </>,
  <>
    Values
  </>
];

const SyncSetting = ({ close, sync_settings_details }) => {
  return (
    <div>
      <HeadingTitle title={"Sync Configuration Setting"} center={false} closeModal={close} />

      <div className="table__flow__row" style={{ height : '500px', wordWrap: 'break-word' }}>
        <div className="table-wrapper-pagination">
          <div className="table-container-pagination sync_settings_details">
            {sync_settings_details ? (
              <DataTable
                header={ALTERNATE_HEADER}
                sync_settings_details={sync_settings_details && sync_settings_details}
              />
            ) : (
              <NoData title={"No Results Found"} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SyncSetting;
